import { observable } from 'mobx'
import systemApi from '@api/system'
import { statScreen, getWebSocketUrl } from '@util'
import AuthorizationStore from './authorizationStore'
import accessControlStore from '@components/CertificateStore/store'
import { Modal } from 'hljd'
import { HLJ_MERCHANT_CENTER } from '@constant'
import {
  AUTH_CREATOR,
  PRIVILEDGE_STORAGE_KEY
} from '@merchant-backend/constant'
import { configure } from '@core/fetch'
import { getRequestSerialNo } from '@core/utils'

/**
 * 这个 store 用于存储整个应用的公共变量，
 * 后期需把 Component/Main/store 里的部分逻辑挪过来
 */
class Store {
  @observable merchantInfo = {}
  @observable hasGetMerchantInfo = false
  @observable authList = []

  constructor() {
    this.authorizationStore = new AuthorizationStore()
    this.accessControlStore = accessControlStore

    this.initApp(window.location.hash)

    statScreen()
  }

  initApp = async hash => {
    // 这一步必须放在最前面
    await this.authorizationStore.setUp()

    // 先放开测试
    if (hash.indexOf('cashierNew') === -1) {
      const resp = await systemApi.edit()
      this.setMerchantInfo(resp)
    }

    // 访问权限控制，没有权限跳转至 merchant_register
    const hasAccess = await this.accessControlStore.initial()
    if (hasAccess) {
      // TODO，这个code只用于判断员工管理权限了
      await this.getMerchantCenterAuthCodes()
      this.getAuth()
    }
  }

  getAuth = async () => {
    const { success, data } = await systemApi.authList({
      productType: '1' // 1 商城
    })
    if (success) {
      this.setAuthList(data)
    }
    this.hasGetMerchantInfo = true
  }

  getMerchantCenterAuthCodes = async () => {
    const { success, data } = await systemApi.merchantPermission()
    if (success) {
      sessionStorage.setItem(
        'MERCHANT_CENTER_AUTH_CODES',
        JSON.stringify(data.authCodes || [])
      )
    }
  }

  setAuthList = data => {
    this.authList = (data || {}).list || []
    if (!this.hasAuth()) {
      // 没有任何权限
      Modal.error({
        title: '没有权限！',
        okText: '确定',
        zIndex: 999999,
        onOk: () => {
          window.opener = null
          window.open('', '_self')
          window.close()
          window.close() // 关闭当前页面  close要执行两次，兼容问题
          window.location.href = HLJ_MERCHANT_CENTER // 防止无法关闭页面
        }
      })
    }
    sessionStorage.setItem(
      PRIVILEDGE_STORAGE_KEY,
      JSON.stringify(this.authList)
    )
  }

  /**
   * 是否有商城权限
   */
  hasAuth = () => {
    if (this.authList.length == 0) {
      return false
    }

    // 有企业创建人权限
    if (this.authList.includes(AUTH_CREATOR)) {
      return true
    }

    let auth = false
    for (let i = 0; i < this.authList.length; i++) {
      if (this.authList[i].startsWith('1_')) {
        auth = true
        break
      }
    }

    return auth
  }

  setMerchantInfo = resp => {
    const { success, data } = resp
    this.merchantInfo = success ? data : {}

    if (success) {
      configure({
        config: config => {
          config.headers['token'] = data.user_token
          return config
        },
        beforeRequest: (url, headers) => {
          const ws_url = getWebSocketUrl().domain
          if (url.includes(ws_url)) {
            delete headers['token']
          }

          headers['request-serial-no'] = getRequestSerialNo(
            'localMerchantReact'
          )
          return headers
        }
      })
    }

    sessionStorage.setItem('merchant_info', JSON.stringify(this.merchantInfo))
  }
}

export default Store
